"use client";

import { logData } from "@jetblue/dotcom-fe-logger";
import { useReportWebVitals } from "next/web-vitals";

export const WebVitals = () => {
  useReportWebVitals((metric: unknown) => {
    console.log(metric);
    void logData({ data: metric, type: "web-vitals" }, "performance");
  });
  return null;
};
